import { createFileRoute } from '@tanstack/react-router'
import { JobScreen } from '@/features/jobs/routes/job-screen'

export const Route = createFileRoute('/jobs/$jobId')({ component: JobPage })

function JobPage() {
  const { jobId } = Route.useParams()
  return <JobScreen jobId={jobId} />
}
